<template lang="pug">
  .module__main
    .module__title Статистика обменника
    .module-content__container
      .filters__container
        .date__container
          el-date-picker(
            v-model="dates"
            type="datetimerange"
            range-separator="-"
            start-placeholder="От"
            end-placeholder="До"
          )
        el-button(type="primary" @click="getStats" :disabled="!isCanSearch") Запросить
      .stats__block
        .stats__container(v-if="statsLoaded")
          .stats__title Общая статистика
          .stat__container
            .stat__title Заявок всего:
            .stat__value {{ stats.total.orders_amount }}
          .stat__container
            .stat__title Заявок завершено:
            .stat__value {{ `${stats.total.finished_amount} (${stats.total.finished_percent}%)` }}
          .stat__container
            .stat__title Заявок отменено:
            .stat__value {{ `${stats.total.canceled_amount} (${stats.total.canceled_percent}%)` }}
          .stat__container
            .stat__title Заявок отказано:
            .stat__value {{ `${stats.total.refused_amount} (${stats.total.refused_percent}%)` }}
          .stat__container
            .stat__title Общий оборот:
            .stat__value {{ `${stats.total.turnover_fiat} р. (${stats.total.turnover_crypto} BTC)` }}
          .stat__container
            .stat__title Оборот завершенных:
            .stat__value {{ `${stats.total.finished_turnover_fiat} р. (${stats.total.finished_turnover_crypto} BTC)` }}
          .stat__container
            .stat__title Оборот отмененных:
            .stat__value {{ `${stats.total.canceled_turnover_fiat} р. (${stats.total.canceled_turnover_crypto} BTC)` }}
          .stat__container
            .stat__title Оборот отказных:
            .stat__value {{ `${stats.total.refused_turnover_fiat} р. (${stats.total.refused_turnover_crypto} BTC)` }}
          .stat__container(v-if="stats.total.profit || stats.total.profit === 0")
            .stat__title Прибыль:
            .stat__value {{ stats.total.profit }}

          .stat__delimiter
          .stats__title Статистика по платежным системам
          .stat-payment-system__container(v-for="(paymentSystemStats, paymentSystem) in stats.payments_systems")
            i.stats__title {{ paymentSystems[paymentSystem] || paymentSystem }}
            .stat__container
              .stat__title Заявок всего:
              .stat__value {{ paymentSystemStats.orders_amount }}
            .stat__container
              .stat__title Заявок завершено:
              .stat__value {{ `${paymentSystemStats.finished_amount} (${paymentSystemStats.finished_percent}%)` }}
            .stat__container
              .stat__title Заявок отменено:
              .stat__value {{ `${paymentSystemStats.canceled_amount} (${paymentSystemStats.canceled_percent}%)` }}
            .stat__container
              .stat__title Заявок отказано:
              .stat__value {{ `${paymentSystemStats.refused_amount} (${paymentSystemStats.refused_percent}%)` }}
            .stat__container
              .stat__title Общий оборот:
              .stat__value {{ `${paymentSystemStats.turnover_fiat} р. (${paymentSystemStats.turnover_crypto} BTC)` }}
            .stat__container
              .stat__title Оборот завершенных:
              .stat__value {{ `${paymentSystemStats.finished_turnover_fiat} р. (${paymentSystemStats.finished_turnover_crypto} BTC)` }}
            .stat__container
              .stat__title Оборот отмененных:
              .stat__value {{ `${paymentSystemStats.canceled_turnover_fiat} р. (${paymentSystemStats.canceled_turnover_crypto} BTC)` }}
            .stat__container
              .stat__title Оборот отказных:
              .stat__value {{ `${paymentSystemStats.refused_turnover_fiat} р. (${paymentSystemStats.refused_turnover_crypto} BTC)` }}
            .stat__container(v-if="paymentSystemStats.profit || paymentSystemStats.profit === 0")
              .stat__title Прибыль:
              .stat__value {{ paymentSystemStats.profit }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { LOAD_EXCHANGE_STATS } from '../../store/const/exchange';

export default {
  name: 'ExchangeStats',
  data() {
    return {
      page: 1,
      per_page: 50,
      dates: '',
      methodsLocales: {
        order: 'Заявка',
        panel: 'Панель'
      },
    }
  },
  mounted() {},
  computed: {
    ...mapGetters([
      'loading',
      'error',
    ]),
    ...mapGetters('exchange', [
      'stats',
    ]),
    ...mapGetters('settings', [
      'paymentSystems',
    ]),
    isLoading() {
      return this.loading(LOAD_EXCHANGE_STATS) === 'loading';
    },
    formattedDates() {
      if (this.dates && Array.isArray(this.dates)) {
        const [from, to] = this.dates;
        return {
          from: {
            year: from.getFullYear(),
            month: from.getMonth(),
            day: from.getDate(),
            hours: from.getHours(),
            minutes: from.getMinutes(),
            seconds: from.getSeconds(),
          },
          to: {
            year: to.getFullYear(),
            month: to.getMonth(),
            day: to.getDate(),
            hours: to.getHours(),
            minutes: to.getMinutes(),
            seconds: to.getSeconds(),
          },
        };
      } else {
        return false;
      }
    },
    isCanSearch() {
      return !!this.formattedDates ?? !this.isLoading;
    },
    statsLoaded() {
      return !!this.stats.total;
    }
  },
  methods: {
    ...mapActions('exchange', {
      loadStats: LOAD_EXCHANGE_STATS,
    }),
    async getStats() {
      await this.loadStats({
        dates: this.formattedDates,
      });
    },
  }
};
</script>
<style scoped>
.filters__container {
  display: flex;
  padding: 5px;
  background-color: #efefef;
  align-content: center;
}

.stats__block {
  display: flex;
  flex-wrap: wrap;
  overflow-y: scroll;
}

.stats__container {
  padding: 8px;
  margin: 5px 4px;
  border-radius: 10px;
  background-color: #efefef;
  width: fit-content;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.stats__title {
  font-weight: bold;
  font-size: 12px;
  margin-bottom: 5px;
}

.stat__container {
  font-family: monospace;
}

.date__container {
  margin: 0 10px;
}

.stat__title {
  font-weight: 500;
  margin-right: 5px;
  display: inline-block;
}

.stat__value {
  display: inline-block;
}

.stat__delimiter {
    margin: 5px auto;
}
</style>
